export default __webpack_public_path__ + "static/media/objective.d3530283.png";